import cx from "classnames"
import PropTypes from "prop-types"
import Container from "components/ui/Container"
import Image from "components/ui/Image"

function DarkSection({ className, children, background }) {
  return (
    <section className={cx(className, "relative bg-big-stone")}>
      {background && (
        <div className="absolute top-0 left-0 h-full w-full">
          <Image className="h-full w-full" src={background} />
        </div>
      )}
      <Container className="relative z-10">{children}</Container>
    </section>
  )
}

DarkSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** Content underneath heading */
  children: PropTypes.node,
  /** Component background image */
  background: PropTypes.shape({}),
}

export default DarkSection
